// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1zVX5","label":"styles_label__2ZY23"};